import React, { useState, useEffect } from 'react';
import './Tree.style.css';
import { DownOutlined, RightOutlined } from '@ant-design/icons';

const TreeNode = ({
  item,
  depth = 0,
  expandIcon,
  icon,
  selectedKey,
  onTreeSelect,
}) => {
  const [collapsed, setCollapsed] = useState(true);

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  useEffect(() => {
    if (item.children) {
      const isIncludes = item.children.find((item) => item.key === '-');
      if (isIncludes) {
        setCollapsed(false);
      }
    }
  }, [item]);

  return (
    <div className="tree_item_layout" style={{ paddingLeft: depth * 24 }}>
      <div className="tree_item">
        <span
          onClick={toggleCollapse}
          className={`tree_expand_icon ${item.children ? 'displayed' : ''}`}
        >
          {item?.children?.length > 0 && expandIcon({ collapsed })}
        </span>

        <span
          className={`tree_item_title ${
            selectedKey === item.key ? 'selected' : ''
          } ${item.key === '-' ? 'creating' : ''}`}
          onClick={() => onTreeSelect({ ...item, depth })}
        >
          {icon[depth] && (
            <span className="tree_item_icon">{icon[depth]({ collapsed })}</span>
          )}
          <span className="tree_item_title_txt">{item.title}</span>
        </span>
      </div>
      {!collapsed && item.children && (
        <div className="tree_item_children">
          {item.children.map((subitem) => (
            <TreeNode
              key={subitem.key}
              item={subitem}
              depth={depth + 1}
              expandIcon={expandIcon}
              icon={icon}
              selectedKey={selectedKey}
              onTreeSelect={onTreeSelect}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const Tree = ({
  data = [],
  expandIcon = ({ collapsed }) =>
    collapsed ? <RightOutlined /> : <DownOutlined />,
  icon = {},
  onSelect = () => {},
  onDeSelect = () => {},
}) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  const [selectedKey, setSelectedKey] = useState(null);

  /* ===== Hooks ===== */
  /* ===== Function ===== */
  const handleTreeSelect = (item) => {
    const type = selectedKey === item.key ? 'deselect' : 'select';
    setSelectedKey(type === 'select' ? item.key : null);
    if (type === 'select') onSelect && onSelect(item.key, item);
    else onDeSelect && onDeSelect(item.key, item);
  };
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <div>
      {data?.map((_item, _index) => (
        <TreeNode
          key={`${_item.key}`}
          item={_item}
          expandIcon={expandIcon}
          icon={icon}
          selectedKey={selectedKey}
          onTreeSelect={handleTreeSelect}
        />
      ))}
    </div>
  );
};

export default Tree;
